import script from "./CPA.vue?vue&type=script&setup=true&lang=js"
export * from "./CPA.vue?vue&type=script&setup=true&lang=js"

import "./CPA.vue?vue&type=style&index=0&id=53753aeb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53753aeb"]])

export default __exports__